import { toast } from 'sonner';
import { ApolloError } from '@apollo/client';

const ErrorMessages = {
  GENERAL: 'An error has occurred! Please try again later.',
  NETWORK: 'A network error has occurred. Please try again later.',
};

export const useErrorHandler = () => {
  const cleanAuthError = (message: string): string => {
    // Remove Cognito Lambda trigger prefixes from error messages
    // e.g., "PreSignUp failed with error Please complete CAPTCHA." -> "Please complete CAPTCHA."
    const triggerPrefixes = [
      'PreSignUp failed with error ',
      'PreAuthentication failed with error ',
      'CustomMessage failed with error ',
      'PostAuthentication failed with error ',
      'PostConfirmation failed with error ',
    ];

    for (const prefix of triggerPrefixes) {
      if (message.startsWith(prefix)) {
        return message.substring(prefix.length);
      }
    }

    return message;
  };

  const handleAuthError = (reason: string | object) => {
    if (reason) {
      switch (typeof reason) {
        case 'object':
          'message' in reason
            ? toast.error(cleanAuthError(reason.message as string))
            : toast.error(ErrorMessages.GENERAL);
          break;
        case 'string':
          toast.error(cleanAuthError(reason));
          break;
        default:
          toast.error(ErrorMessages.GENERAL);
      }
    } else {
      toast.error(ErrorMessages.GENERAL);
    }
  };

  const handleApolloError = ({
    graphQLErrors,
    clientErrors,
    networkError: apolloNetworkError,
  }: ApolloError) => {
    if (apolloNetworkError) {
      toast.error(ErrorMessages.NETWORK);
    } else {
      toast.error(ErrorMessages.GENERAL);
    }
  };

  const handleHttpClientError = () => {
    toast.error(ErrorMessages.GENERAL);
  };

  // `description` renders as a second, quieter line under the message. Optional
  // so the existing single-argument callers are unaffected.
  const handleGeneralAppError = (message?: string, description?: string) => {
    toast.error(
      message || ErrorMessages.GENERAL,
      description ? { description } : undefined
    );
  };

  return {
    handleAuthError,
    handleApolloError,
    handleHttpClientError,
    handleGeneralAppError,
  };
};
